const host = 'https://epsg.io/trans';
const t_srs = 4326; //gps坐标系的编码
let count = 1;
export function transformCgcs({ x, y, s_srs = 4547 }) {
  return new Promise((resolve, reject) => {
    const method = `handleJsonpSuccess${count}`;
    count++;
    window[method] = resolve;
    const url = `${host}?x=${x}&y=${y}&s_srs=${s_srs}&t_srs=${t_srs}&callback=${method}`;
    const script = document.createElement('script');
    script.src = url;
    document.body.append(script);
    script.addEventListener('load', () => {
      //
      // let result = callback();
      //
      window[method] = undefined;
      document.body.removeChild(script);
    });
    // script.addEventListener('error', reject);
  });
}
